import { render, staticRenderFns } from "./WorkflowsIndex.vue?vue&type=template&id=54e952c7"
import script from "./WorkflowsIndex.vue?vue&type=script&lang=js"
export * from "./WorkflowsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports